'use strict';
'use es6';

// eslint-disable-next-line no-unused-vars

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Forbidden;
function Forbidden(props, propName, componentName, location) {
  if (props.hasOwnProperty(propName)) {
    return new Error('Forbidden prop `' + propName + '` supplied to ' + componentName);
  }
  return null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.42/js/propTypes/Forbidden.js
// module id = 193
// module chunks = 0